import type { AxiosInstance } from 'axios';
import type {
  Document,
  DocumentListQueryParams,
  DocumentListResponse,
  DocumentCreateRequest,
  DocumentUpdateRequest,
  EntityId,
} from '@/types';

export const getDocuments = async (
  api: AxiosInstance,
  document_type_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<DocumentListResponse> => {
  const resp = await api.get<DocumentListResponse>('/document', {
    params: { document_type_id, limit, start_key, name } as DocumentListQueryParams,
  });
  return resp.data;
};

export const getActiveDocuments = async (
  api: AxiosInstance,
  document_type_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<DocumentListResponse> => {
  const resp = await api.get<DocumentListResponse>('/document/active', {
    params: { document_type_id, limit, start_key, name } as DocumentListQueryParams,
  });
  return resp.data;
};

export const getDocument = async (
  api: AxiosInstance,
  document_id: EntityId,
): Promise<Document> => {
  const resp = await api.get<Document>(`/document/${document_id}`);
  return resp.data;
};

export const createDocument = async (
  api: AxiosInstance,
  values: DocumentCreateRequest,
): Promise<Document> => {
  const resp = await api.post<Document>(`/document/`, values);
  return resp.data;
};

export const updateDocument = async (
  api: AxiosInstance,
  document_id: EntityId,
  values: DocumentUpdateRequest,
): Promise<Document> => {
  const resp = await api.put<Document>(`/document/${document_id}`, values);
  return resp.data;
};

export const rerunDocumentProcessing = async (
  api: AxiosInstance,
  document_id: EntityId,
): Promise<Document> => {
  const resp = await api.put<Document>(`/document/${document_id}/reprocess`, {});
  return resp.data;
};

export const deleteDocument = async (
  api: AxiosInstance,
  document_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/document/${document_id}`);
  return resp.data;
};

